import react from "react";


const INITIALSTATE = {
    currentdeed: null,
    alldeeds: [],
    displayadd: false,
    currentmrtg: null,
    allmrtgs: [],
    displayaddmrtg: false
}

const LoadDeedReducer = (state = INITIALSTATE, action) => {
    switch (action.type) {
        case "LoadAllDeeds":
            return { ...state, alldeeds: action.data };
        case "ShowAddDeed" :
            return { ...state, displayadd: true };
        case "HideAddDeed" :
            return { ...state, displayadd: false };
        case "SetDeed" :
            return { ...state, currentdeed: action.data };
        case "LoadAllMrtgs":
            return { ...state, allmrtgs: action.data };
        case "ShowAddMrtg" :
            return { ...state, displayaddmrtg: true };
        case "HideAddMrtg" :
            return { ...state, displayaddmrtg: false };
        case "SetMrtg" :
            return { ...state, currentmrtg: action.data };
        default: return state;

    };
}

export default LoadDeedReducer;